// @flow
import { schema } from 'normalizr';

export const recipe = new schema.Entity('recipes');

export const recipes = new schema.Array(recipe);
